import React from 'react';
import { I18n } from '@fiverr-private/fiverr_context';
import { Tag, Tooltip } from '@fiverr-private/fit';

import './style.scss';

const TeamBadge = () => (
    <Tooltip
        className="team-badge-tooltip"
        contentClassName="team-badge-tooltip-content"
        boxContentClassName="team-badge-tooltip-box"
        content={<I18n k="collections_perseus.tooltips.team" />}
        appendToBody={false}
    >
        <Tag className="team-badge" size={Tag.SIZES.TINY} color={Tag.COLORS.BLUE} kind={Tag.KINDS.FULL}>
            <I18n k="collections_perseus.general.team" />
        </Tag>
    </Tooltip>
);

export default TeamBadge;
